import { Grid, TextField } from "@mui/material";
import { FieldValues, UseFormRegister } from "react-hook-form";
import type { FullAddress, IErrors } from "./types";
import { useAppSelector } from "../../redux";
import { selectText } from "../LanguageSelect/LanguageSelectSlice";
import { AcctionButtons } from "../CompletionPage/AcctionButtons";

interface IAddressFeildsProps {
  fullAddress: FullAddress | null;
  errors: IErrors;
  setErrors(erros: IErrors): void;
  register: UseFormRegister<FieldValues>;
  updateFullAddress(key: string, value: string): void;
  setFullAddress(address: FullAddress | null): void;
  updateFullAddress(value: string, key: string): void;
  handleClose(): void;
}

export function AddressFields(props: IAddressFeildsProps) {
  const { errors, register, fullAddress, updateFullAddress, handleClose } = props;

  const text = useAppSelector(selectText);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <TextField
          {...register("street")}
          variant="outlined"
          sx={{ direction: "ltr" }}
          fullWidth
          name="street"
          rows={15}
          type="input"
          label={text.formsFeilds.street}
          value={fullAddress ? fullAddress.street : ""}
          helperText={errors.street?.err ? errors.street.msg : ""}
          error={errors.street?.err ? true : false}
          onKeyDown={handleKeyDown}
          onChange={(e) => updateFullAddress(e.target.value, "street")}
        />
      </Grid>
      <Grid item xs={6} sm={3} md={3} lg={3} xl={3}>
        <TextField
          {...register("building")}
          variant="outlined"
          sx={{ direction: "ltr" }}
          fullWidth
          name="building"
          rows={15}
          type="input"
          label={text.formsFeilds.building}
          value={fullAddress ? fullAddress.building : ""}
          helperText={errors.building?.err ? errors.building.msg : ""}
          error={errors.building?.err ? true : false}
          onKeyDown={handleKeyDown}
          onChange={(e) => updateFullAddress(e.target.value, "building")}
        />
      </Grid>
      <Grid item xs={6} sm={3} md={3} lg={3} xl={3}>
        <TextField
          {...register("apt")}
          variant="outlined"
          sx={{ direction: "ltr" }}
          fullWidth
          name="apt"
          rows={15}
          type="input"
          label={text.formsFeilds.apt}
          value={fullAddress ? fullAddress.apt : ""}
          helperText={errors.apt?.err ? errors.apt.msg : ""}
          error={errors.apt?.err ? true : false}
          onKeyDown={handleKeyDown}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <TextField
          {...register("country")}
          variant="outlined"
          sx={{ direction: "ltr" }}
          fullWidth
          name="country"
          rows={15}
          type="input"
          label={text.formsFeilds.country}
          value={fullAddress ? fullAddress.country : ""}
          helperText={errors.country?.err ? errors.country.msg : ""}
          onKeyDown={handleKeyDown}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <TextField
          {...register("state")}
          variant="outlined"
          sx={{ direction: "ltr" }}
          fullWidth
          name="state"
          rows={15}
          type="input"
          label={text.formsFeilds.state}
          value={fullAddress ? fullAddress.state : ""}
          onKeyDown={handleKeyDown}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <TextField
          {...register("city")}
          variant="outlined"
          sx={{ direction: "ltr" }}
          fullWidth
          name="city"
          rows={15}
          type="input"
          label={text.formsFeilds.city}
          onChange={(e) => updateFullAddress(e.target.value, "city")}
          value={fullAddress ? fullAddress.city : ""}
          error={errors.city?.err ? true : false}
          onKeyDown={handleKeyDown}
          helperText={errors.city?.err ? errors.city.msg : ""}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <TextField
          {...register("zipcode")}
          variant="outlined"
          sx={{ direction: "ltr" }}
          fullWidth
          name="zipcode"
          rows={15}
          type="input"
          label={text.formsFeilds.zipcode}
          value={fullAddress ? fullAddress.zipcode : ""}
          error={errors.zipcode?.err ? true : false}
          helperText={errors.zipcode?.err ? errors.zipcode.msg : ""}
          onChange={(e) => updateFullAddress(e.target.value, "zipcode")}
          onKeyDown={handleKeyDown}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Grid container>
          <AcctionButtons handleClose={handleClose} action={() => {}} type="submit" title={text.update} />
        </Grid>
      </Grid>
    </Grid>
  );
}
